import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from "vuetify/es5/locale/es";
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
  },
  lang: {
    locales: { es },
    current: "es",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#FB8200",
        secondary: "#0BC6D7",
        accent: "#8c9eff",
        error: "#ff5252",
      },
    },
  },
});
